package business

data class CampaignConfig(
    val referralCode: String,
    val referralDiscountRub: Double,
    val commissionRub: Double,
    val providerName: String,
    val campaignId: String,
    val leadEndpointUrl: String,
    val eventEndpointUrl: String,
)

val defaultCampaignConfig = CampaignConfig(
    referralCode = "REF358",
    referralDiscountRub = 5_000.0,
    commissionRub = 5_000.0,
    providerName = "партнер по оформлению карты АТЭС",
    campaignId = "apec-card-calculator-static",
    leadEndpointUrl = "",
    eventEndpointUrl = "",
)
